import React, { useState } from 'react';
import './Footer.css';
import { WechatOutlined, TaobaoOutlined } from '@ant-design/icons';
import jdIcon from '../assets/icon/jd.png';
import qrCodeIcon from '../assets/icon/qr_code.png';

const Footer: React.FC = () => {
  const [showQrCode, setShowQrCode] = useState(false);
  return (
    <footer id="contact" className="footer">
      <div className="footer-red-bar"></div>
      <div className="container">
        <div className="footer-content">
          <div className="footer-top">
            <nav className="footer-nav">
              <p>公司地址：河南省开封市七大街以东陇海二路以南河南泰丰生物科技有限公司院内3号楼8号房</p>
              <p>咨询电话：（0371）86230086  86230087</p>
              <p>电话号码：（0371）23268178  23268908</p>
            </nav>
            <div className="purchase-section">
              <span className="purchase-label">购买链接：</span>
              <div className="purchase-icons">
                <div 
                  className="purchase-icon-item wechat-item"
                  onMouseEnter={() => setShowQrCode(true)}
                  onMouseLeave={() => setShowQrCode(false)}
                >
                  <span className="icon">
                    <WechatOutlined style={{ color: '#5D5D5D' }} />
                  </span>
                  <span className="icon-label">微信购买</span>
                  {showQrCode && (
                    <div className="qr-code-tooltip">
                      <div className="qr-tooltip-content">
                        <div className="qr-tooltip-title">微信扫码购买</div>
                        <img src={qrCodeIcon} alt="微信二维码" />
                      </div>
                      <div className="qr-tooltip-arrow"></div>
                    </div>
                  )}
                </div>
                <div 
                  className="purchase-icon-item"
                  onClick={() => window.open('https://jieyu.jd.com/', '_blank')}
                >
                  <span className="icon">
                    <img src={jdIcon} alt="京东店铺" />
                  </span>
                  <span className="icon-label">京东店铺</span>
                </div>
                <div 
                  className="purchase-icon-item"
                  onClick={() => window.open('https://tstfdyf.tmall.com/', '_blank')}
                >
                  <span className="icon">
                    <TaobaoOutlined style={{ color: '#5D5D5D' }} />
                  </span>
                  <span className="icon-label">淘宝店铺</span>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <p>备案编号：豫网药信备字[2025]00210号</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 